import React, { useState, useEffect } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import "./informes.scss"
import InformesView from "./informes.view";
import {
    Table,
    Tag,
    Space,
    Row,
    Col,
    Menu,
    Button,
    Modal,
    Input,
    Tabs,
    List,
    Form,
    notification,
    Popconfirm
} from 'antd';
import {DownloadOutlined, LeftOutlined, ShareAltOutlined, UsergroupAddOutlined} from "@ant-design/icons";
import variables from "../../../_constants/variables";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import InformesOrientador from "./informesOrientador";

import { xcService } from "../../../_services/xcService";
import CardStudent from "./cardStudent";
function Informes() {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const userType = storage.getItem(variables.USER_TYPE);
    const userStorage = JSON.parse(storage.getItem(variables.USER));

    const [showInviteUserModal, setShowInviteUserModal] = useState(false);
    const [userFamily, setUserFamily] = useState(null);
    const [studentProfile, setStudentProfile] = useState();
    const onFinishInvite = (values) => {

        xcService.postToken('/v1/student/invite', values).then(({ data }) => {

            setShowInviteUserModal(false);
            notification["success"]({
                message: t("invita.enviada"),
                description:
                    t("invita.subenviada"),
            });
        });


    };

    const onFinishInviteFailed = (errorInfo) => {

        setShowInviteUserModal(false);
    };

    useEffect(() => {

        let userFamily;
        if (userType === 'FAMILY') {
            setUserFamily({
                name: userStorage.name,
                uid: userStorage.student
            });

            xcService.getToken(`/v1/student/${userStorage.student}/profile`)
                .then(({data}) => setStudentProfile(data.data))
        }

    },[userType])



    return (
        userType === 'STUDENT' ?
            <>

                {showInviteUserModal &&
                    <Modal className={"modalName modal-question modal-question--tutor"}
                        title={t("invitarfamilia")}
                        centered
                        visible={showInviteUserModal}
                        onCancel={() => setShowInviteUserModal(false)}
                    >
                        <Form
                            form={form}
                            name="basic"
                            layout="vertical"
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            initialValues={{ remember: true }}
                            autoComplete="off"
                            onFinish={onFinishInvite}
                            onFinishFailed={onFinishInviteFailed}
                        >
                            <p>{t("invita.title")}</p>

                            <Form.Item
                                label={t("registro.name")}
                                name="name" rules={[{
                                    required: true, message: t("mandatory"),
                                },]}
                            >
                                <Input placeholder={t("registro.namep")} />
                            </Form.Item>
                            <Form.Item
                                label={t("registro.surname")}
                                name="surname" rules={[{
                                    required: true, message: t("mandatory"),
                                },]}
                            >
                                <Input placeholder={t("registro.surnamep")} />
                            </Form.Item>
                            <Form.Item
                                name="email"
                                label={t("invita.mailf")}
                                rules={[{
                                    type: "email", message: t("registro.emailIncorrect"),
                                }, {
                                    required: true, message: t("mandatory"),
                                },]}
                            >
                                <Input placeholder={t("invita.mailf")} />
                            </Form.Item>
                            <Form.Item
                                name="emailrep"
                                label={t("invita.confirma")}
                                rules={[{
                                    type: "email", message: t("registro.emailIncorrect"),
                                }, {
                                    required: true, message: t("mandatory"),
                                }, ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('email') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(t("registro.emailmis")));
                                    },
                                }),]}
                            >
                                <Input placeholder={t("invita.confirma")} />
                            </Form.Item>
                            <Form.Item className="buttons-pre-next">
                                <Button type="primary" htmlType="submit">
                                    {t("account.save")}
                                </Button>

                                <Button onClick={() => setShowInviteUserModal(false)}
                                    className="modal-question--button modal-question--button--cancel"
                                    htmlType="button">{t("tutores.informes.cancel")}</Button>
                            </Form.Item>
                        </Form>
                    </Modal>
                }
                <div className="container container--informes boxed boxed--informes">
                    <div className={"informes-header"}>
                        <div className={"informes-header__top"}>
                            <h1 className={"is-first"}>{t("informes.title")}</h1>
                            <Button onClick={() => setShowInviteUserModal(true)} className={"btnWhiteBlue"}><UsergroupAddOutlined />{t("informes.familyButton")}</Button>
                        </div>
                        <p>{t("informes.subtitle")}</p>

                    </div>


                    <InformesView student={true} />
                </div></>
            :
            userType !== 'TUTOR' && userType !== 'FAMILY' ? <InformesOrientador /> :
                userType === 'FAMILY' ? <>
                    <div className="container container--informes boxed boxed--informes">
                        <div className={"informes-header"}>
                            <div className={"informes-header__top"}>
                                <h1 className={"is-first"}>{t("informes.title")}</h1>

                            </div>

                        </div>
                        {studentProfile &&  <div style={{width: 500}}><CardStudent t={t} studentProfile={studentProfile} isForFamily={true}/></div>}
                        {userFamily &&
                            <InformesView student={true} user={userFamily} family={true}/>
                        }
                    </div>


                </> : <></>
    )
}

export default withTranslation()(Informes)
